import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { TranslateService } from '@ngx-translate/core';
import errorJson from './i18n/us.json';
import { ResponseError } from '../../models';
import { AlertService } from '../alert/alert.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerServiceService {
  constructor(
    private logger: NGXLogger,
    private alertService: AlertService,
    private translateService: TranslateService
  ) {}

  public handleError(e: any): void {
    const error: ResponseError = e?.error;

    if (!error) {
      this.logger.error(e);
    } else {
      this.logger.error(error);
    }

    if (!error) {
      // tolerant frontend error -> no need to alert
      return;
    }

    if (!error.status) {
      this.alertService.alertErrorMessage(
        this.translateService.instant(
          'error-handler-service.text.server-connection-error'
        )
      );
    } else if (this.isMessageLocalizationExisted(error?.message)) {
      this.alertService.alertErrorMessage(
        this.translateService.instant(
          `error-handler-service.backend-message.${error.message}`
        )
      );
    } else {
      this.alertService.alertErrorMessage(
        this.translateService.instant(
          'error-handler-service.text.general-error'
        )
      );
    }
  }

  private isMessageLocalizationExisted(message: string): boolean {
    if (!message?.length) {
      return false;
    }
    const localizationPath = [
      'error-handler-service',
      'backend-message',
      ...message.split('.'),
    ];
    return !!this.getValueOfLocalizationFromPath(errorJson, localizationPath);
  }

  private getValueOfLocalizationFromPath(
    textObject: any,
    localizationPath: string[]
  ): any {
    if (localizationPath?.length <= 0) {
      return textObject;
    }

    const textObjectNextDeepLevel = textObject?.[localizationPath[0]];
    if (textObjectNextDeepLevel) {
      return this.getValueOfLocalizationFromPath(
        textObjectNextDeepLevel,
        localizationPath.slice(1)
      );
    } else {
      return null;
    }
  }
}
